import React from 'react';
import styled from 'styled-components';

import type { CourseDto } from '@/application/interfaces/pegasus.gateway';

import VideoIcon from './icons/video.svg';

const Container = styled.a`
  margin: 0px 8px;
  display: block;
  color: #ffffff;
  :hover {
    cursor: pointer;
  }
`;

const ImageWrapper = styled.div`
  background: var(--gray-01);
  height: 140px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
`;

const Image = styled.img`
  width: 100%;
`;

const Name = styled.div`
  font-weight: 700;
  font-size: 16px;
  letter-spacing: -0.4px;
  padding: 8px 0 8px;
  text-overflow: ellipsis;
  overflow: hidden;
  ${Container}:hover & {
    text-decoration: underline;
  }
`;

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Infos = styled.div`
  display: flex;
  flex: 1;
  gap: 8px;
`;

const InfoItem = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const InfoIcon = styled.img``;

const InfoLabel = styled.div`
  font-weight: 400;
  font-size: 14px;
`;

const ProgressWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 4px;
  background: var(--gray-03);
`;

const ProgressContent = styled.div<{ progress?: number }>`
  height: 4px;
  width: ${({ progress }) => progress || 0}%;
  background: var(--green-principal);
`;

type Props = {
  course: CourseDto;
  weekOrder?: number;
};

const CourseItem: React.FC<Props> = ({ course, weekOrder }) => {
  const getCourseUrl = () => {
    return `/classroom/study-plan/${weekOrder}/course/${course.guid}`;
  };

  const calculateProgress = (course: CourseDto) => {
    if (course?.lessons.every((lesson) => lesson.isComplete)) return 100;

    const percentageAverage =
      course?.lessons.reduce((accumulator, lesson) => {
        return accumulator + lesson.percentualProgress;
      }, 0) / course?.lessons.length;

    if (percentageAverage) return percentageAverage * 100;

    return 0;
  };

  const totalLessons = course.lessons.length;

  return (
    <Container href={getCourseUrl()}>
      <ImageWrapper>
        {course.thumbnail && <Image src={course.thumbnail} />}
        <ProgressWrapper>
          <ProgressContent progress={calculateProgress(course)} />
        </ProgressWrapper>
      </ImageWrapper>
      <Name>{course.name}</Name>
      <Footer>
        <Infos>
          <InfoItem>
            <InfoIcon src={VideoIcon} />
            <InfoLabel>
              {totalLessons} {totalLessons > 1 ? 'aulas' : 'aula'}
            </InfoLabel>
          </InfoItem>
        </Infos>
      </Footer>
    </Container>
  );
};

export default CourseItem;
